














import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {TagHelper} from '@/mixins/TagHelper';

@Component
export default class Tags extends mixins(TagHelper) {
    selectedTags: Tag[] = [];

    get tagList() {
        return this.$store.state.tagList;
    }

    created() {
        this.$store.commit('fetchTags');
    }

    toggle(tag: Tag) {
        if (this.selectedTags.length > 0) {
            this.selectedTags.pop();
        }
        this.selectedTags.push(tag);
        this.$emit('update:selected', this.selectedTags);
    }

}
